import { FC, useState } from 'react';
import { Check, Close } from '@mui/icons-material';
import { styled, IconButton, TextField, CircularProgress } from '@mui/material';
import { Row } from 'further-ui/components/Layout';
import api from 'lib/trpcClient';
import useHandleTrpcMutation from 'hooks/ui/useHandleTrpcMutation';
import { useLayoutContext } from 'contexts/LayoutContext';

const CheckIcon = styled(Check)({
  width: 16,
  height: 16,
});
const CloseIcon = styled(Close)({
  width: 16,
  height: 16,
});

type ViewEditDocumentNameProps = {
  documentId: string;
  documentName: string;
  isBeingRenamed: boolean;
  onCompletion: () => void;
};

const ViewEditDocumentName: FC<ViewEditDocumentNameProps> = ({
  documentId,
  documentName,
  isBeingRenamed,
  onCompletion,
}) => {
  const { selectedVehicleId } = useLayoutContext();
  const [newDocumentName, setNewDocumentName] = useState(documentName);

  const { mutate: updateDocumentName, isPending: isUpdatingDocumentName } =
    api.vehicleSigningDocument.updateDocumentName.useMutation(
      useHandleTrpcMutation()({
        successMessage: 'Document name updated successfully.',
        onSuccess: () => {
          onCompletion();
        },
      }),
    );

  if (!selectedVehicleId) {
    return <>{documentName}</>;
  }

  const handleCancel = () => {
    onCompletion();
    setNewDocumentName(documentName);
  };

  const handleSave = () => {
    if (
      newDocumentName.trim() === '' ||
      newDocumentName.trim() === documentName
    ) {
      onCompletion();
      setNewDocumentName(documentName);
      return;
    }

    updateDocumentName({
      vehicleSigningDocumentId: documentId,
      vehicleId: selectedVehicleId,
      newDocumentName,
    });
  };

  return (
    <Row centered spacing="xs">
      {isBeingRenamed ? (
        <>
          <TextField
            fullWidth
            size="small"
            value={newDocumentName}
            disabled={isUpdatingDocumentName}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleSave();
              }
            }}
            onChange={(e) => {
              setNewDocumentName(e.target.value);
            }}
          />
          {!isUpdatingDocumentName ? (
            <>
              <IconButton size="small" onClick={handleSave}>
                <CheckIcon />
              </IconButton>
              <IconButton size="small" onClick={handleCancel}>
                <CloseIcon />
              </IconButton>
            </>
          ) : (
            <IconButton size="small" disabled>
              <CircularProgress size={16} />
            </IconButton>
          )}
        </>
      ) : (
        documentName
      )}
    </Row>
  );
};

export default ViewEditDocumentName;
